<div>
	<app-features></app-features>
</div>
